import { defineStore } from "pinia";
import { getI18n } from "@plugins/i18n/index";

export const useAppStore = defineStore("app", () => {
  const i18n = getI18n();
  const { t } = i18n.global;

  const provinces = ref([]);
  const expandVerticalNav = ref(true);
  const mobileNav = ref(false);
  const appAlerts = ref([]);
  const waitingFor = ref([]);
  const isAppReady = ref(false);
  const isNotiSnackbarVisible = ref(false);
  const notiSnackbarContent = ref({
    timeout: 5000,
    message: "",
    color: "info",
  });
  const searchUserAndCommsDialog = ref(false);
  const privateChatDialog = ref(false);
  const rewardsDialog = ref(false);
  const presaleDialog = ref(false);

  const addAlert = (message, options = {}) => {
    const {
      type = "info",
      color = "",
      icon = "",
      iconSvg = null,
      iconComponent = null,
      iconProps = null,
      timeout = 3000,
      ...rest
    } = options || {};

    const alert = {
      message,
      type,
      color,
      icon,
      iconSvg,
      iconComponent,
      iconProps,
      timeout,
      timeoutId: null,
      ...rest,
    };
    appAlerts.value.unshift(alert);

    alert.timeoutId = setTimeout(() => {
      removeAlert(appAlerts.value.indexOf(alert));
    }, timeout);
  };

  const removeAlert = (index) => {
    if (index >= 0 && index < appAlerts.value.length) {
      const [alert] = appAlerts.value.splice(index, 1);
      if (alert.timeoutId) {
        clearTimeout(alert.timeoutId);
      }
    }
  };

  const showErrorsAlert = (errors) => {
    // const { t } = useI18n();

    const defaultMessage = t("error_occurred");

    if (Array.isArray(errors)) {
      errors.forEach((err) => {
        const message = t(`error_message.${err.message}`, defaultMessage);
        addAlert(message, {
          type: "error",
          color: "error",
          icon: "mdi-alert-circle",
          timeout: 3000,
        });
      });
    } else {
      addAlert(defaultMessage, {
        type: "error",
        color: "error",
        icon: "mdi-alert-circle",
        timeout: 3000,
      });
    }
  };

  const showNotiSnackbar = (content) => {
    // const { t } = useI18n();

    notiSnackbarContent.value = {
      ...notiSnackbarContent.value,
      ...content,
      message: t(content.message),
    };

    isNotiSnackbarVisible.value = true;
  };

  const clearNotiSnackbar = () => {
    notiSnackbarContent.value = {
      timeout: 5000,
      message: "",
      color: "info",
    };
  };

  const startLoadingScreen = (key, options = {}) => {
    const { blocking = true } = options;

    if (!waitingFor.value.some((item) => item.key === key)) {
      waitingFor.value.push({ key, blocking });
    }
  };

  const endLoadingScreen = (key) => {
    waitingFor.value = waitingFor.value.filter((item) => item.key !== key);
  };

  const openMobileNav = () => {
    mobileNav.value = true;
  };

  const closeMobileNav = () => {
    mobileNav.value = false;
  };

  const openSearchDialog = () => {
    searchUserAndCommsDialog.value = true;
  };

  const closeSearchDialog = () => {
    searchUserAndCommsDialog.value = false;
  };

  const openPrivateChatDialog = () => {
    privateChatDialog.value = true;
  };

  const closePrivateChatDialog = () => {
    privateChatDialog.value = false;
  };

  const openRewardsDialog = () => {
    rewardsDialog.value = true;
  };

  const closeRewardsDialog = () => {
    rewardsDialog.value = false;
  };

  const openPresaleDialog = () => {
    presaleDialog.value = true;
  };

  const closePresaleDialog = () => {
    presaleDialog.value = false;
  };

  return {
    provinces,
    expandVerticalNav,
    appAlerts,
    waitingFor,
    isNotiSnackbarVisible,
    notiSnackbarContent,
    mobileNav,
    isAppReady,
    searchUserAndCommsDialog,
    privateChatDialog,
    rewardsDialog,
    presaleDialog,
    addAlert,
    removeAlert,
    showErrorsAlert,
    showNotiSnackbar,
    clearNotiSnackbar,
    openMobileNav,
    closeMobileNav,
    startLoadingScreen,
    endLoadingScreen,
    openSearchDialog,
    closeSearchDialog,
    openPrivateChatDialog,
    closePrivateChatDialog,
    openRewardsDialog,
    closeRewardsDialog,
    openPresaleDialog,
    closePresaleDialog,
  };
});
